export default __webpack_public_path__ + "static/media/pinterest-logo.0c0a86b4.png";